if(document.getElementById('io-posts')) {
  
  var request = new XMLHttpRequest();
  request.open('GET', 'https://io.education/wp-json/wp/v2/hub', true);
  
  request.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      // Success!
      var ioposts = JSON.parse(this.responseText);
      document.getElementById('io-posts').innerHTML = "";
  
      for(var i=0; i < 3; i++){
        iopost = ioposts[i];
        document.getElementById("io-posts").innerHTML += '<div class="col col-lg-4"> <a class="hub-card" href=\"' + iopost.link + '\">' + '<div class="hub-card__inner "><div class="hub-card__image hub-card__image--hmpg"><img src=\"' + iopost.featured_image_src + '\"></div>' + '<div class="hub-card__content"><div class="hub-card__category"><span class="btn--small-border-radius" style="background:#ffffff; color: #0a0a0a" href="https://io.education/inside-out-categories/insight/">IO</span></div>' + '<div class="hub-card__text"><p class="h3">' + iopost.title.rendered + '</p></div></div></div></a></div>';
      }
  
    }
  };
  
  request.onerror = function() {
    console.log('CONNECTION ERROR')
  };
  
  request.send();  
}
